<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="xl"
  >
    <template #header>
      {{$t('modals.excmtask.dispatchTaskModalHeader')}}
    </template>
    <template #body>
      <b-row v-if="task">
        <b-col cols="12">
          <b-form-group>
            <label for="userData" class="form-control-label">
              {{$t('modals.excmtask.dispatchUserData')}}:
            </label>
            <model-select id="userData" v-model="idUserData" :options="userDataOptions"></model-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" v-if="isDailyPlanItem">
          <b-form-group>
            <label for="date" class="form-control-label">
              {{$t('modals.excmtask.date')}}:
            </label>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              id="date"
              v-model="date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="6" v-if="isDailyPlanItem">
          <b-form-group>
            <label
              for="excmdailyplan_deletedAt"
              class="form-control-label">{{$t('modals.excmtask.timeStartOnCalendar')}}:</label>
            <VueCtkDateTimePicker no-header
                                  :label="$t('modals.excmtask.timeStartOnCalendar')"
                                  v-model="timeStartOnCalendar"
                                  format="HH:mm"
                                  :right="true"
                                  only-time
                                  formatted="HH:mm"
            >
            </VueCtkDateTimePicker>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="isDailyPlanItem">
          <b-form-group>
            <label for="moveReason">
              {{ $t('modals.dailyplan.moveReason') }}:
            </label>
            <b-form-textarea
              id="moveReason"
              v-model="moveReason"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-btn variant="success" @click="transfer()">{{ $t('buttons.transferToAnotherUserDataTask') }}</b-btn>
          <b-btn variant="danger" @click="hideModal()">{{ $t('buttons.cancel') }}</b-btn>
        </b-col>
      </b-row>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { ModelSelect } from 'vue-search-select'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import { ENTRYPOINT } from '@/config/entrypoint'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'TransferTaskModal',
  components: {
    BaseModal,
    ModelSelect,
    VueCtkDateTimePicker
  },

  props: {
    task: {
      type: Object,
      required: true
    }
  },

  computed: {
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    isDailyPlanItem () {
      return !!(this.task.dailyPlanItems && this.task.dailyPlanItems.length > 0)
    },
    ...mapGetters({
      isVisible: 'excmtask/transferModal/isVisible',
      userDataList: 'userdata/list/items'
    }),
    userDataOptions () {
      return this.userDataList.map(entry => {
        return {
          value: entry['@id'],
          text: entry.fullName
        }
      })
    }
  },

  data () {
    return {
      idUserData: '',
      date: '',
      timeStartOnCalendar: '',
      moveReason: ''
    }
  },

  created () {
    this.setCurrentUser()
  },
  watch: {
    task: {
      deep: true,
      handler (val) {
        this.getTechnicians(val.idTaskType['@id'])
      }
    }
  },
  methods: {
    ...mapMutations({
      toggleModal: 'excmtask/transferModal/toggleModal'
    }),
    ...mapActions({
      getUserData: 'userdata/list/default'
    }),
    transfer () {
      if (this.isDailyPlanItem) {
        this.transferDailyPlanItem()
      } else {
        this.transferTask()
      }
    },
    async transferTask () {
      let link = `e_x_c_m_tasks/${getId(this.task['@id'])}/transfer?idUserData=${getId(this.idUserData)}`
      const response = await new ApiService(link).put({})
      if (response.status === 200) {
        this.successHandler()
      }
    },
    async transferDailyPlanItem () {
      let lastDailyPlanItem = this.task.dailyPlanItems[this.task.dailyPlanItems.length - 1]
      if (typeof lastDailyPlanItem === 'object') {
        lastDailyPlanItem = lastDailyPlanItem['@id']
      }
      let link = `e_x_c_m_daily_plan_items/${getId(lastDailyPlanItem)}/move`
      let data = {
        idUserData: getId(this.idUserData),
        date: this.date,
        timeStartOnCalendar: this.timeStartOnCalendar,
        moveReason: this.moveReason
      }
      const response = await new ApiService(link).post(data)
      if (response.status === 201) {
        this.successHandler()
      }
    },
    successHandler () {
      this.$emit('success')
      this.hideModal()
    },
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    reset () {
      this.setCurrentUser()
      this.date = ''
      this.timeStartOnCalendar = ''
      this.moveReason = ''
    },
    async getTechnicians (idTaskType = undefined) {
      let params = { pagination: false, isCompany: 0, isContractor: 0 }
      if (idTaskType) {
        params.applicableForTaskType = idTaskType
      }
      let link = addParamsToQuery('user_datas/list', params)
      this.getUserData(link)
    },
    setCurrentUser () {
      this.idUserData = this.path + 'user_datas/' + getUserRoles().id_userdata
    }
  }
}
</script>

<style scoped>

</style>
